export default "__VITE_ASSET__9587af9b__"